
import AgricultureStatsPropertyView from "./AgricultureStatsPropertyView";
import { HarvestResult } from "types/agriculture/states-type";
import AgricultureStatsSectionView from "./AgricultureStatsSectionView";

const AgricultureStatsHarvests = (props: { harvest: HarvestResult | undefined | null }) => {

    if (!props.harvest) {
        return <></>;
    }

    return <AgricultureStatsSectionView title="agriculture.stats.harvest">
        <div className="flex flex-wrap">
            <AgricultureStatsPropertyView label="agriculture.stats.expenses" value={props.harvest?.totalExpense} propertyType="money" />
            <AgricultureStatsPropertyView label="agriculture.stats.days" value={props.harvest?.totalCount} propertyType="number" />
            <AgricultureStatsPropertyView label="agriculture.stats.workers-count" value={props.harvest?.totalWorkers} propertyType="number" />
        </div>
        <div className="flex flex-wrap">
            <AgricultureStatsPropertyView label="agriculture.stats.kg-per-day" value={props.harvest?.kgPerDay} propertyType="wight" />
            <AgricultureStatsPropertyView label="agriculture.stats.kg-per-worker" value={props.harvest?.kgPerWorker} propertyType="wight" />
        </div>
        <div className="flex flex-wrap">
            <AgricultureStatsPropertyView label="agriculture.stats.cart-per-day" value={props.harvest?.cartPerDay} propertyType="number" />
            <AgricultureStatsPropertyView label="agriculture.stats.cart-per-worker" value={props.harvest?.cartPerWorker} propertyType="number" />
            <AgricultureStatsPropertyView label="agriculture.stats.kg-per-cart" value={props.harvest?.kgPerCart} propertyType="wight" />
        </div>
    </AgricultureStatsSectionView>
};

export default AgricultureStatsHarvests;
